// Texty mobilního draweru navigace (mobileNav.js) — drill-down zprava dle
// handoveru Claude Design (design_handoff_mobilni_menu).

import { plural } from '../plural.js';

export default {
  closeMenu: 'Zavřít menu',
  rootMenu: 'Hlavní menu',
  showAll: 'Zobrazit vše',
  nav: 'Menu',
  support: 'Potřebujete poradit?',
  showSubcats: 'Zobrazit podkategorie',
  search: {
    placeholder: 'Hledat kategorii…',
    clear: 'Smazat hledání',
    empty: 'Nic jsme nenašli. Zkuste jiný výraz, nebo projděte kategorie níže.',
  },
  /** tmavé tlačítko pod kategoriemi */
  orderStatus: 'Stav objednávky',
  /** sekce „Nakupování" — přihlášení/registrace, reklamace, vrácení */
  shop: {
    account: 'Přihlášení / registrace',
    claim: 'Reklamace zboží',
    withdrawal: 'Vrácení do 14 dnů',
  },
  /** sekce s podstránkami shopu (název eshopu jako eyebrow — viz `SHOP.shop.name`) */
  site: {
    shipping: 'Doprava a platba',
    store: 'Kamenná prodejna Bílina',
    service: 'Servis nářadí',
    b2b: 'B2B spolupráce',
    ratings: 'Hodnocení obchodu',
    contact: 'Kontakty',
  },
  /** eyebrow nad úvodním seznamem kategorií (úroveň 1) */
  categoriesEyebrow: 'Kategorie',
  eyebrowShopping: 'Nakupování',
  /** „1 kategorie" / „2 kategorie" / „5 kategorií" — v hlavičkách panelů */
  categoryCount: (n) => n + ' ' + plural(n, ['kategorie', 'kategorie', 'kategorií']),
  /** „Žádné výsledky" / „1 výsledek" / „2 výsledky" / „5 výsledků" */
  resultsCount: (n) => (n === 0 ? 'Žádné výsledky' : n + ' ' + plural(n, ['výsledek', 'výsledky', 'výsledků'])),
};
